module.exports = __webpack_public_path__ + "static/media/opensans-semibold-webfont.b1c1678e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-semibold-webfont.woff2
// module id = 1011
// module chunks = 0